import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { McdInvPrioritizationGrid } from '../charts/McdInvPrioritizationGrid';
import { McdInvPriorQtrPercentCompleteChart } from '../charts/McdInvPriorQtrPercentCompleteChart';
import { McdInvProgressChart } from '../charts/McdInvProgressChart';
import { McdInvSlaCartesianChart } from '../charts/McdInvSlaCartesianChart';
import { McdStlmntProgressChart } from '../charts/McdPymtProgressChart';

export const McdInvDashboardOperationsView = ({ formValues, endDateToStartDate, idToMcdInvOrigin }) => {
    return (
        <SpacerLayout>
        <Spacer vertical>

          {/* Row 1 */}
          <Spacer weights={[1, 1, 1.75]}>
            <DashboardCard title="Invoice Progress" sx={{ flex: 1 }}>
              <McdInvProgressChart
                formValues={formValues}
                endDateToStartDate={endDateToStartDate}
                idToMcdInvOrigin={idToMcdInvOrigin}
              />
            </DashboardCard>

            <DashboardCard title="Settlement Progress" sx={{ flex: 1 }}>
              <McdStlmntProgressChart
                formValues={formValues}
                endDateToStartDate={endDateToStartDate}
              />
            </DashboardCard>

            <DashboardCard title="Prioritization Grid" sx={{ height: '100%' }}>
              <McdInvPrioritizationGrid
                formValues={formValues}
                endDateToStartDate={endDateToStartDate}
                idToMcdInvOrigin={idToMcdInvOrigin}
              />
            </DashboardCard>
          </Spacer>

          {/* Row 2 */}
          <Spacer weights={[1, 1, 1.75]}>
            <DashboardCard title="CLD Progress" sx={{ height: '100%' }}>
              <McdInvProgressChart
                formValues={formValues}
                endDateToStartDate={endDateToStartDate}
                idToMcdInvOrigin={idToMcdInvOrigin}
                isCld
              />
            </DashboardCard>

            <DashboardCard title="Prior Quarter % Completion" sx={{ height: '100%' }}>
              <McdInvPriorQtrPercentCompleteChart
                formValues={formValues}
              />
            </DashboardCard>

            <DashboardCard title="SLA Tracker" sx={{ height: '100%' }}>
              <McdInvSlaCartesianChart
                formValues={formValues}
              />
            </DashboardCard>
          </Spacer>

        </Spacer>
      </SpacerLayout>
    )
}